import { IcoRemove, InfoIcon } from "@/utils/icons";
import classes from "./index.module.css";
import { Tooltip } from "antd";
import classNames from "classnames";

const ActionModal = ({
  title,
  content,
  additionalInfo = null,
  onDismiss = () => {},
  onAction = () => {},
  className = undefined,
}) => {
  const onSubmit = (e) => {
    e.preventDefault();
    onAction();
  };

  return (
    <div className={classNames(classes.modalContainer, className)}>
      <div className={classes.modalHeader}>
        <div className={classes.modalTitleContainer}>
          <span className={classes.modalHeaderTitle}>{title}</span>
          {additionalInfo && (
            <Tooltip title={additionalInfo}>
              <InfoIcon />
            </Tooltip>
          )}
        </div>
        <div className={classes.closeIcon} onClick={onDismiss}>
          <IcoRemove />
        </div>
      </div>
      <form {...{ onSubmit }} className={classes.formWrapper}>
        <span className={classes.contentWrapper}>{content}</span>
        <div>
          <button className={classes.submitButton} type="submit" newDesign>
            Подтвердить
          </button>
        </div>
      </form>
    </div>
  );
};

export default ActionModal;
